module.exports = ".searchbar{\r\n    padding:10px;\r\n    background: #212121;\r\n}\r\n\r\nlabel{\r\n    color:#fff;\r\n    margin-top:8px;\r\n}\r\n\r\n.form-control{\r\n    padding:4px;\r\n}\r\n\r\nselect.form-control:not([size]):not([multiple]) {\r\n    height: calc(2rem + 2px);\r\n}\r\n\r\nbutton{\r\n    width:100px;\r\n    margin-right: 5px;\r\n}\r\n\r\ntd{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles-grid/roles-grid.component.css
// module id = ./src/app/ultilities/roles/roles-grid/roles-grid.component.css
// module chunks = main